import { ArrowRight, ShieldAlert } from 'lucide-react';
import { TASK_VIEW_DENIED_MESSAGES } from '../../../core/task-views';
import type { TaskViewDeniedReason } from '../../../core/task-views';

interface AccessDeniedViewProps {
  /** Which door was closed — decides the sentence under the icon. */
  reason?: TaskViewDeniedReason;
  /** The message the router already resolved, when it has one. */
  message?: string;
  onBack: () => void;
}

/**
 * The third answer of the router: this account has no business on this task.
 * It deliberately shows nothing about the task itself — not its title, not its
 * destination, not its crew — so a refused view can never become a leak.
 */
export function AccessDeniedView({ reason, message, onBack }: AccessDeniedViewProps) {
  const text = message ?? TASK_VIEW_DENIED_MESSAGES[reason ?? 'NOT_ASSIGNED'];

  return (
    <div className="mx-auto w-full max-w-md space-y-4 py-8 text-center">
      <div className="mx-auto w-14 h-14 rounded-2xl border border-rose-200 bg-rose-50 flex items-center justify-center">
        <ShieldAlert size={26} className="text-rose-600" aria-hidden />
      </div>
      <div className="space-y-1">
        <h2 className="text-lg font-bold">אין גישה למשימה</h2>
        <p className="text-sm text-ink/60">{text}</p>
      </div>
      <p className="text-xs text-ink/40">
        אם לדעתך מדובר בטעות, פנה למנהל העבודה כדי שישבץ אותך לצוות המשימה.
      </p>
      <button
        type="button"
        onClick={onBack}
        className="h-11 px-5 rounded-xl border border-line text-sm text-ink/70 hover:text-ink inline-flex items-center gap-2"
      >
        <ArrowRight size={16} aria-hidden />
        חזרה ללוח המשימות
      </button>
    </div>
  );
}
